import PropTypes from "prop-types";
import { Fragment, memo, useState } from "react";
import cns from "classnames";
import {
  formLabel,
  formDropdown,
  selectedItm,
  validationError,
} from "@/assets/styles/common.module.scss";
import { IMAGE_BASE_PATH } from "@/config/config";
import classNames from "classnames";

const Divider = memo(function divider() {
  <span className="p-0" style={{ borderTop: "1px dashed #bcbcbc" }} />;
});

const LabelDropDown = ({
  lblTxt,
  dropdownNm,
  title,
  items = [],
  onSelect,
  parentClass = "",
  childClass = "",
  error = "",
  refreshErrors = () => {},
  sumInsuredDropdown,
  customDropdown,
  ...restProps
}) => {
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const toggleDropDown = () => setDropDownOpen((m) => !m);

  const handleBlur = () => {
    if (refreshErrors) {
      refreshErrors(dropdownNm);
    }
    setDropDownOpen(false);
  };

  const handleSelect = (e, id) => {
    e.stopPropagation();
    const evt = { target: {} };
    evt.target.name = dropdownNm;
    evt.target.value = id;
    onSelect(evt);
    setDropDownOpen(false);
  };

  const displayTitle = title === 0 ? "0" : title || `Select ${lblTxt}`;

  return (
    <section
      className={cns("d-flex flex-column flex-column-reverse", parentClass)}
      {...restProps}
    >
      {error && (
        <aside className={cns(formLabel, validationError)}>
          {error || ""}&nbsp;
        </aside>
      )}
      <article
        className={cns(
          "d-flex align-items-center rounded-pill",
          formDropdown,
          childClass
        )}
        tabIndex={-1}
        onBlur={handleBlur}
      >
        <article
          className={`mb-0 ${
            sumInsuredDropdown || customDropdown
              ? "flexSpaceAround"
              : "flexCenter"
          }`}
          name={dropdownNm}
          value={title}
          onClick={toggleDropDown}
          aria-hidden="true"
        >
          <div>{displayTitle}</div>
          <div
            className={`mb-2 ${
              sumInsuredDropdown || customDropdown ? "" : "me-auto"
            }`}
          >
            {dropDownOpen ? (
              // <img src={Resources.images.iconUp} alt="" />
              <img
                src={`${IMAGE_BASE_PATH}/images/iconUp.svg`}
                alt=""
                className={classNames({ "d-none": items.length === 1 })}
              />
            ) : (
              <img
                src={`${IMAGE_BASE_PATH}/images/iconDown.svg`}
                alt=""
                className={classNames({ "d-none": items.length === 1 })}
              />
            )}
          </div>
        </article>

        {dropDownOpen && (
          <aside className="d-flex flex-column dropdown-content">
            {items.length > (sumInsuredDropdown ? 1 : 0) &&
              items.map(({ id, value }, idx) => (
                <Fragment key={id}>
                  <div
                    className={cns(
                      String(value).toLowerCase() ===
                        String(title).toLowerCase()
                        ? selectedItm
                        : null
                    )}
                    onClick={(e) => handleSelect(e, id)}
                    aria-hidden="true"
                  >
                    {value}
                  </div>
                  {idx < items.length - 1 && <Divider />}
                </Fragment>
              ))}
          </aside>
        )}
      </article>
      {sumInsuredDropdown || customDropdown ? null : (
        <label htmlFor={dropdownNm} className={cns("d-block", formLabel)}>
          {lblTxt}
        </label>
      )}
    </section>
  );
};

LabelDropDown.propTypes = {
  childClass: PropTypes.string,
  dropdownNm: PropTypes.any,
  error: PropTypes.string,
  items: PropTypes.array,
  lblTxt: PropTypes.any,
  onSelect: PropTypes.func,
  parentClass: PropTypes.string,
  refreshErrors: PropTypes.func,
  title: PropTypes.any,
  sumInsuredDropdown: PropTypes.bool,
  customDropdown: PropTypes.bool,
};

function arePropsEqual(prevProp, nextProp) {
  return (
    prevProp.title === nextProp.title && prevProp.onSelect === nextProp.onSelect
  );
}

export default memo(LabelDropDown, arePropsEqual);
